import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useForm } from 'react-hook-form'
import { useStyles } from './FormEtatCivilStyle'
import SelectPays from '../../SelectPays/SelectPays'
import allActions from '../../../redux/actions/user'
import { useDispatch, useSelector } from 'react-redux'
import TabNavigation from '../../TabNavigation/TabNavigation'

//Material UI
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import frLocale from 'date-fns/locale/fr'


export default function FormEtatCivil(props) {

  const dispatch = useDispatch()
  const classes = useStyles()
  const { formClass, defaultValues, refresh, pays, situations, id, nextTab, previousTab } = props
  const state = useSelector(state => state)
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''

  const { register, handleSubmit } = useForm()
  const { enqueueSnackbar } = useSnackbar()
  const date = defaultValues?.date || 0
  const [selectedDate, setSelectedDate] = useState(new Date(date))
  const handleDateChange = (date) => setSelectedDate(date)
  const [situation, setSituation] = useState(defaultValues?.situation ?? '')


  async function save(data, e) {
    if (isNaN(selectedDate.getTime())) return
    data = {
      ...data,
      date: selectedDate,
      situation: situation === '' ? null : situation,
      category: 1
    }
    const result = await allActions.fetchPostAPI(`api/users/modifs-infos-perso/${id}`, data, dispatch, token)

    //Si la requête n'a pas fonctionnné une erreur est affiché
    if (result.err) {
      enqueueSnackbar('Erreur: ' + result.err, { variant: `error` })
      return
    }

    //Si le serveur retourne une erreur elle est affiché
    if (result?.json.err) {
      enqueueSnackbar('Erreur: ' + result.json.err, { variant: `error` })
      return
    }

    enqueueSnackbar('Enregistré !', { variant: `success` })
    refresh(result.json.data)

    const action = e.nativeEvent.submitter.dataset.action
    if (action === 'previous' && previousTab) previousTab()
    else if (action === 'next') nextTab()
  }

  return (
    <form onSubmit={handleSubmit(save)}>
      <div className={formClass}>
        <div className={classes.datePicker}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <KeyboardDatePicker
              inputVariant="outlined"
              required
              value={selectedDate}
              onChange={handleDateChange}
              format="dd/MM/yyyy"
              label="Date de naissance"
              invalidDateMessage="Date invalide"
              cancelLabel="Annuler"
              disableFuture
            />
          </MuiPickersUtilsProvider>
        </div>
        <TextField
          label="Lieu de naissance"
          variant="outlined"
          type="text"
          name="lieu"
          margin="dense"
          inputRef={register}
          defaultValue={defaultValues?.lieu}
        />

        <SelectPays
          register={register}
          label="Nationalité"
          name="nationalite"
          defaultValue={defaultValues?.nationalite}
          setPays={() => {}}
          pays={pays}
        />

        <TextField
          select
          label="Situation"
          variant="outlined"
          value={situation}
          onChange={(e) => setSituation(e.target.value)}
          margin="dense"
        >
          {[ { id: '', libelle: 'ㅤ' }, ...situations].map((s, i) => (<MenuItem value={s.id} key={i}>{s.libelle}</MenuItem>))}
        </TextField>
      </div>


      <TabNavigation save previous next/>
    </form>
  )
}

